import { Component, OnInit } from '@angular/core';
import { PortalService } from '../../services/portal.service';
import { ReferralInfo } from '../../models/referral-info.model';
import { MatDialog } from '@angular/material';
import { ReferralInfoDialogComponent } from '../referral-info-dialog/referral-info-dialog.component';

@Component({
  selector: 'referral-search',
  templateUrl: './referral-search.component.html',
  styleUrls: ['./referral-search.component.scss']
})
export class ReferralSearchComponent implements OnInit {

  searchQuery: string = '';

  constructor(private portalService: PortalService,
    private matDialog: MatDialog) { }

  ngOnInit() {
  }

  search() {
    if(this.searchQuery.length === 0)
      return;
    this.portalService.getReferralInfo(this.searchQuery)
      .subscribe((referralInfo: ReferralInfo) => {
        const data = {
          referral: referralInfo,
          hasReferral: true
        };
        this.openDialog(data);
    }, error => {
        const data = {
          referral: {referralNumber: this.searchQuery},
          hasReferral: false
        };
        this.openDialog(data);
      })
  }

  openDialog(data: any) {
    this.matDialog.open(ReferralInfoDialogComponent, {
      data: data,
      width: '500px',
    });
  }

}
